var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "voiceRecorder" } }, [
    _c(
      "div",
      {
        staticClass: "trigger-button",
        on: {
          click: function ($event) {
            return _vm.$feature.beforeSendFileMessage(_vm.record)
          },
        },
      },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _vm.isRecording
      ? _c(
          "div",
          { staticClass: "voice-record-phase" },
          [
            _c(
              "md-button",
              {
                staticClass: "actionBtn",
                attrs: { id: "cancelBtn" },
                on: {
                  click: function () {
                    return _vm.stopRecord(true)
                  },
                },
              },
              [_c("md-icon", { staticClass: "icon" }, [_vm._v("delete")])],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "frequence" },
              [
                _c("av-media", {
                  attrs: {
                    id: "av-media",
                    media: _vm.media,
                    type: "frequ",
                    canvWidth: 50,
                    canvHeight: 20,
                    lineColor: "white",
                    "frequ-lnum": "15",
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }